<template>
  <div >
    <b-container fluid class="md-content">
        <div class="md-header">Bereiche</div>
        <b-card>
            <b-row>
                <b-col>
                    <b-button variant="success" @click="showModal('modal-createbu')">Bereich anlegen</b-button>
                </b-col>
                <b-col>
                    <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-if="businessunits != undefined">
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="businessunits" :fields="fields">
                        <template slot="actions" slot-scope="row">
                            <b-button class="mx-1" size="sm" v-on:click="openEditModal(row)"><i class="fas fa-pencil-alt"></i></b-button>
                            <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteModal(row)"><i class="fas fa-trash"></i></b-button>
                        </template>
                        
                    </b-table>
                </b-col>
            </b-row>
        </b-card>
      
    </b-container>

    <b-modal ref="modal-createbu"  no-close-on-backdrop no-close-on-esc centered title="Bereich anlegen" @cancel="hideModal('modal-createbu')" @ok="createBusinessUnit" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                <b-form-group label-cols="4" label-cols-lg="2" label="Name" label-for="newbuname">
                    <b-form-input id="newbuname" v-model="buname"></b-form-input>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="2" label="" label-for="bucheck">
                     <b-form-checkbox id="bucheck" v-model="createWithSpotAndSkill">
                        Mit Position und Skill
                    </b-form-checkbox>
                </b-form-group>
            </div>
            
            <b-row v-if="buerror">
                Fehler beim Erstellen des Bereichs.
            </b-row>
        </b-container>
    </b-modal>
    <b-modal ref="modal-editbu"  no-close-on-backdrop no-close-on-esc centered title="Bereich bearbeiten" @cancel="hideModal('modal-editbu')" @ok="editBusinessUnit" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                <b-form-group label-cols="4" label-cols-lg="2" label="Name" label-for="newbuname">
                    <b-form-input id="newbuname" v-model="buname"></b-form-input>
                </b-form-group>
            </div>
            <b-row v-if="buerror">
                Fehler beim Bearbeiten des Bereichs.
            </b-row>
        </b-container>
    </b-modal>
    <b-modal ref="modal-deletebu"  no-close-on-backdrop no-close-on-esc centered title="Bereich löschen" @cancel="hideModal('modal-deletebu')" @ok="deleteBusinessUnit" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie den Bereich {{buname}} löschen wollen?</p>
            </b-row>
            <b-row v-if="buerror">
                Fehler beim Löschen des Bereichs.
            </b-row>
        </b-container>
    </b-modal>

  </div>

</template>

<script>
export default {
  name: 'businessunit',
  data () {
    return {
      businessunits: [],
      fields: [{key:"name", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"actions",label: "", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: false}],
      buname: "",
      buid:"",
      currentrow: {},
      buerror: false,
      createWithSpotAndSkill: false,
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function() {
        let view = this;
        this.loadBusinessUnits()
        .then(response=>{
            view.updateBusinessUnits(response.data)
            
        })
        .catch(function (error) {
            console.log(error)
        });
    },
    createBusinessUnit: function(evt){
        evt.preventDefault();
        this.buerror=false;
        let view = this;
        let url = '/api/sec/businessunit';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/businessunit');
        

        let payload = {
          storeId: this.$store.state.storeId,
          name: this.buname,
          createWithSpotAndSkill: this.createWithSpotAndSkill,
        }

        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            console.log(response)
            if(this.createWithSpotAndSkill){
                let unit = {
                    id: response.data.data.businessunit.id,
                    name: response.data.data.businessunit.name
                }
                view.businessunits.push(unit);
            } else {
                let unit = {
                    id: response.data.data.id,
                    name: response.data.data.name
                }
                view.businessunits.push(unit);
            }
            
            view.hideModal('modal-createbu');
        }).catch(function (error) {
            view.buerror=true;
            console.log(error)
        })

    },
    openEditModal: function(row){
        this.currentrow = row;
        this.buname = row.item.name;
        this.buid = row.item.id;
        this.showModal('modal-editbu');
    },
    editBusinessUnit: function(evt){
        evt.preventDefault();
        this.buerror=false;
        let view = this;
        let url = '/api/sec/businessunit';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/businessunit');
        
        let payload = {
          id: this.buid,
          name: this.buname,
          updateFields: ["name"]
        }

        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.currentrow.item.name=view.buname;
            view.hideModal('modal-editbu');
        }).catch(function (error) {
            view.buerror=true;
            console.log(error)
        })

    },
    openDeleteModal: function(row){
        this.currentrow = row;
        this.buname = row.item.name;
        this.buid = row.item.id;
        this.showModal('modal-deletebu');
    },
    deleteBusinessUnit: function(evt){
        evt.preventDefault();
        this.buerror=false;
        let view = this;
        let url = '/api/sec/businessunit';
        
        url = this.$helpers.appendParam("id", this.buid, url, '/api/sec/businessunit');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/businessunit');
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.businessunits.findIndex(bu => bu.id === view.buid) // find the businessunit index 
            if (~index) {
                view.businessunits.splice(index, 1);
            }     
            view.hideModal('modal-deletebu');
        }).catch(function (error) {
            view.buerror=true;
            console.log(error)
        })

    },
    loadBusinessUnits : function() {
      let view = this;
      let url = '/api/sec/businessunit';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/businessunit');
      

      return this.axios({
        method: 'get',
        headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
        url: url
      })
        
        
    },
    
    updateBusinessUnits: function(data) {
        let overviewA = [];
        var i;
        for (i = 0; i < data.length; i++) { 
            let designItem = {
                id: data[i].id,
                name: data[i].name
            }
            overviewA.push(designItem);
        }
      
        this.businessunits = overviewA;
    },
    hideModal (ref) {
        this.buerror=false;
        this.buid="";
        this.buname="";
        this.currentrow={};
        this.createWithSpotAndSkill = false;
        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  components: {
  },
  computed: {
   
  },
  watch: { 
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
